import CheckItems from '@components/Fireboard/components/Body/CheckDetails/CheckItems.jsx';
import ActionButtons from '@components/Fireboard/components/Body/CheckDetails/ActionButton.js';
import cn from 'classnames';
import style from './expandedView.module.css';
import { ReactComponent as LeftArrow } from '@assets/images/Fireboard/leftnavarrow.svg';
import { ReactComponent as RightArrow } from '@assets/images/Fireboard/rightnavarrow.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import constant from '@components/common/globalization';
import { useNavigate } from 'react-router-dom';
import { APP_CONFIG } from '@constants';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const ExpandCheckDetail = props => {
  const {
    filteredCheck,
    mode,
    currency,
    setIsFlip,
    updateOrderStatus,
    setIsExpanded,
    handleNextCheck,
    handlePrevCheck,
    setPopup,
    traceClick,
  } = props;
  return (
    <div className="w-100 h-100 position-relative">
      <RightSectionHeader
        setIsExpanded={setIsExpanded}
        length={filteredCheck?.AllItems?.length ?? 0}
        handleNextCheck={handleNextCheck}
        handlePrevCheck={handlePrevCheck}
        setPopup={setPopup}
        traceClick={traceClick}
      />
      <CheckItems
        itemslist={filteredCheck?.AllItems}
        filteredCheck
        currency={currency}
        selectedItem={filteredCheck}
        isExpanded={true}
        mode={mode}
      />
      <ActionButtons
        mode={mode}
        item={filteredCheck}
        setIsFlip={setIsFlip}
        updateOrderStatus={updateOrderStatus}
        isExpanded={true}
      />
    </div>
  );
};

export default ExpandCheckDetail;

const RightSectionHeader = ({
  setIsExpanded,
  length,
  handleNextCheck,
  handlePrevCheck,
  setPopup,
  traceClick,
}) => {
  const navigate = useNavigate();
  const onClickOfCross = prev => {
    setIsExpanded(!prev);
    if (traceClick === constant.NOTIFICATIONS) {
      navigate(`${APP_CONFIG.BASE_URL}/fireboard/notifications`);
    }
  };

  return (
    <div className={cn('pb-3', style.rightSectionSubSection)}>
      <div className="d-flex justify-content-between">
        <div className={cn('d-flex align-items-center', style.itemCountFs)}>
          {FLABEL().DETAILS_ITEMS} ({length})
        </div>
        <div className={cn('d-flex', style.navGap)}>
          <span
            onClick={() => handlePrevCheck()}
            className={cn(style.navigationIcon)}
          >
            <LeftArrow />
          </span>
          <span
            onClick={() => handleNextCheck()}
            className={cn(style.navigationIcon)}
          >
            <RightArrow />
          </span>
          <span
            onClick={prev => onClickOfCross(prev)}
            className={cn(style.crossIcon)}
          >
            <Cross fill="var(--primary-icon-color)" />
          </span>
        </div>
      </div>
    </div>
  );
};
